import React from "react";
import baguette from "../../assets/images/baguette-crumbs.png";

export default () => (
  <div className="cb-c-error-view__container">
    <section className="cb-c-error-view">
      <header>
        <h1 className="cb-c-error-view__title">Aw, crumbs!</h1>

        <img src={baguette} alt="Crumbs" className="cb-c-error-view__image" />
      </header>

      <h3>It looks like something has gone wrong</h3>
    </section>
  </div>
);
